import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { RetweetOutlined } from '@ant-design/icons';
import { MenuItemDef, GetContextMenuItemsParams } from 'ag-grid-community';
import { McaFeeTransactionsDocument, McaTransactionsDocument, MerchantCashAdvanceDocument, TransactionType } from '../../graphql/types';

interface ContextMenuProps {
  params: GetContextMenuItemsParams;
  updateTransactionType: (variables: { variables: { id: string; mcaId: string; type: TransactionType } }) => void;
  mcaId: string;
  isSuperAdmin: boolean;
  allowedEditableTransactionTypes: TransactionType[];
}

const getContextMenuItems = ({
  params,
  updateTransactionType,
  mcaId,
  isSuperAdmin,
  allowedEditableTransactionTypes
}: ContextMenuProps): (MenuItemDef | string)[] => {
  const transactionTypes = [
    {
      name: 'DEBIT',
      type: TransactionType.Debit,
      show: params.node.data.type !== TransactionType.Debit && params.node.data?.integration?.id
    },
    {
      name: 'COLLECTION',
      type: TransactionType.Collection,
      show: params.node.data.type !== TransactionType.Collection && params.node.data.type !== TransactionType.Debit
    },
    {
      name: 'ACH PROGRAM FEE',
      type: TransactionType.AchProgramFee,
      show: params.node.data.type !== TransactionType.AchProgramFee
    },
    {
      name: 'OTHER FEE',
      type: TransactionType.OtherFee,
      show: params.node.data.type !== TransactionType.OtherFee
    },
    { name: 'NSF FEE', type: TransactionType.NsfFee, show: params.node.data.type !== TransactionType.NsfFee },
    {
      name: 'DEFAULT FEE',
      type: TransactionType.DefaultFee,
      show: params.node.data.type !== TransactionType.DefaultFee
    }
  ];

  const createAction = (id: string, type: TransactionType) => () => {
    updateTransactionType({
      variables: { id, mcaId, type },
      onCompleted: () => {
        const updatedData = { ...params.node.data, type };
        params.node.setData(updatedData);
        params.api.refreshCells({ rowNodes: [params.node] });
      },
      refetchQueries: [
        {
          query: MerchantCashAdvanceDocument,
          variables: { id: mcaId }
        },
        {
          query: McaTransactionsDocument,
          variables: { id: mcaId }
        },
        {
          query: McaFeeTransactionsDocument,
          variables: { id: mcaId }
        }
      ]
    });
  };

  const result: (MenuItemDef | string)[] = ['copy', 'separator'];

  if (isSuperAdmin && allowedEditableTransactionTypes.includes(params.node.data.type)) {
    result.push({
      name: 'Change Type',
      icon: ReactDOMServer.renderToStaticMarkup(<RetweetOutlined />),
      subMenu: transactionTypes
        .filter(({ show }) => show)
        .map(({ name, type }) => ({
          name,
          action: createAction(params.node.data.id, type)
        }))
    });
  }

  return result;
};

export default getContextMenuItems;
